export var NormalModule;
(function (NormalModule) {
    NormalModule[NormalModule["secondaryBg"] = 0] = "secondaryBg";
    NormalModule[NormalModule["primaryBg"] = 1] = "primaryBg";
})(NormalModule || (NormalModule = {}));
export var ActionType;
(function (ActionType) {
    ActionType["send"] = "click_to_send";
    ActionType["redirect"] = "click_to_redirect";
    ActionType["close"] = "click_to_close_window";
    ActionType["endchat"] = "click_to_endchat";
})(ActionType || (ActionType = {}));
export var UserRoleType;
(function (UserRoleType) {
    UserRoleType["customer"] = "CUSTOMER";
    UserRoleType["system"] = "SYSTEM";
    UserRoleType["agent"] = "AGENT";
})(UserRoleType || (UserRoleType = {}));
export var MessageType;
(function (MessageType) {
    MessageType["multipleDateTimePicker"] = "MultipleDateTimePicker";
    MessageType["tabCard"] = "TabCard";
    MessageType["text"] = "Text";
    MessageType["feedBack"] = "FeedBack";
})(MessageType || (MessageType = {}));
export var ChatEvent;
(function (ChatEvent) {
    ChatEvent["Incoming_message"] = "INCOMING_MESSAGE";
    ChatEvent["Incoming_typing"] = "INCOMING_TYPING";
    ChatEvent["Connection_established"] = "CONNECTION_ESTABLISHED";
    ChatEvent["Connection_lost"] = "CONNECTION_LOST";
    ChatEvent["Connection_broken"] = "CONNECTION_BROKEN";
    ChatEvent["Connection_ack"] = "CONNECTION_ACK";
    ChatEvent["Chat_ended"] = "CHAT_ENDED";
})(ChatEvent || (ChatEvent = {}));
export var ContentType;
(function (ContentType) {
    ContentType["textPlain"] = "text/plain";
    ContentType["textCsv"] = "text/csv";
    ContentType["applicationDoc"] = "application/msword";
    ContentType["applicationPdf"] = "application/pdf";
    ContentType["applicationPpt"] = "application/vnd.ms-powerpoint";
    ContentType["applicationXls"] = "application/vnd.ms-excel";
    ContentType["imageJpg"] = "image/jpeg";
    ContentType["imagePng"] = "image/png";
    ContentType["audioWav"] = "audio/wav";
    ContentType["connectionAcknowledged"] = "application/vnd.amazonaws.connect.event.connection.acknowledged";
    ContentType["typing"] = "application/vnd.amazonaws.connect.event.typing";
    ContentType["participantJoined"] = "application/vnd.amazonaws.connect.event.participant.joined";
    ContentType["participantLeft"] = "application/vnd.amazonaws.connect.event.participant.left";
    ContentType["transferSucceeded"] = "application/vnd.amazonaws.connect.event.transfer.succeeded";
    ContentType["transferFailed"] = "application/vnd.amazonaws.connect.event.transfer.failed";
    ContentType["chatEnded"] = "application/vnd.amazonaws.connect.event.chat.ended";
    ContentType["interactiveMessage"] = "application/vnd.amazonaws.connect.message.interactive";
})(ContentType || (ContentType = {}));
export var ChatConnectStatus;
(function (ChatConnectStatus) {
    ChatConnectStatus[ChatConnectStatus["fail"] = 1] = "fail";
    ChatConnectStatus[ChatConnectStatus["successfull"] = 2] = "successfull";
    ChatConnectStatus[ChatConnectStatus["pending"] = 3] = "pending";
    ChatConnectStatus[ChatConnectStatus["none"] = 4] = "none";
    ChatConnectStatus[ChatConnectStatus["error"] = 5] = "error";
})(ChatConnectStatus || (ChatConnectStatus = {}));
export var FormatConvertType;
(function (FormatConvertType) {
    FormatConvertType["phoneSplitByLine"] = "PhoneSplitByLine";
})(FormatConvertType || (FormatConvertType = {}));
export var AgentCommunicateStatus;
(function (AgentCommunicateStatus) {
    AgentCommunicateStatus[AgentCommunicateStatus["Start"] = 1] = "Start";
    AgentCommunicateStatus[AgentCommunicateStatus["End"] = 2] = "End";
})(AgentCommunicateStatus || (AgentCommunicateStatus = {}));
export var StartChatWithAgentStatus;
(function (StartChatWithAgentStatus) {
    StartChatWithAgentStatus["End"] = "0";
    StartChatWithAgentStatus["Start"] = "1";
})(StartChatWithAgentStatus || (StartChatWithAgentStatus = {}));
export var OperationAction;
(function (OperationAction) {
    OperationAction["Speak_to_live_agent"] = "Speak to a live agent";
})(OperationAction || (OperationAction = {}));
export var LocalStorageKey;
(function (LocalStorageKey) {
    LocalStorageKey["ChatbotConnectionInfo"] = "connectionToken";
    LocalStorageKey["OpenChatbotPageCount"] = "chatbotPageCount";
    LocalStorageKey["StartChatResult"] = "startChatResult";
})(LocalStorageKey || (LocalStorageKey = {}));
export var Env;
(function (Env) {
    Env["Dev"] = "dev";
    Env["Stage"] = "stage";
    Env["Test"] = "test";
    Env["Live"] = "live";
    Env["DCDev"] = "democenterdev";
    Env["DC"] = "democenter";
})(Env || (Env = {}));
export var MessageName;
(function (MessageName) {
    MessageName["StartDescribeIssue"] = "c";
    MessageName["StartChatWithAgent"] = "startChatWithAgent";
    MessageName["Error"] = "startChatWithAgentWithError";
})(MessageName || (MessageName = {}));
export var UserAction;
(function (UserAction) {
    UserAction["CloseBanner"] = "11050";
})(UserAction || (UserAction = {}));
